import React, { useState, useRef } from 'react';
import DatePicker from "react-multi-date-picker";
import { useEvents } from "../../../Hooks/Features/Events/useEvents"
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridReact } from "@ag-grid-community/react";
import { SkeletonDataTable, SkeletonContainer } from "../../../components/Loader/Loader";
import { Dialog } from "primereact/dialog";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CommanDialog from '../../../components/CommonCompo/CommanDialog/CommanDialog';

const Events = () => {

    const { hoveredRange, setHoveredRange, coldef, rowData, setRowData, loader, showPopup, setShowPopup, handleUploadClicked, handleFileChange, imagePreview, setImagePreview, gridRef, handleApproveReject, aInputRef, bInputRef, handleSaveBanner, loaderBtn, getEventsData, bannerLoader, imageSelectedFlag, confirmation, setConfirmation, dataToReject, filterValues, setFilterValues, filterOpts, emailTemplate, setEmailTemplate } = useEvents();
    const [showFiltersDrawer, setShowFiltersDrawer] = useState(false);
    const datePickerRef = useRef(null);

    return (
        <div>
            <div className="d-flex justify-content-between align-items-center mt-2">
                <div></div>
                <div className="d-flex gap-2 align-items-center">
                    <button className="button btn-primary" onClick={() => handleApproveReject(true, true)}>Approve All</button>
                    <button className="button btn-danger" onClick={() => handleApproveReject(false, false)}>Reject All</button>
                    <button className="button btn-default" onClick={() => { setImagePreview({ birthday: null, anniversary: null }); setShowPopup(true); }}>
                        <div className="srkay-settings" style={{ fontSize: "large" }}></div>
                    </button>
                    <button className="button btn-default" onClick={() => { getEventsData() }} title="Refresh">
                        <FontAwesomeIcon icon="fa-solid fa-arrows-rotate" />
                    </button>
                    <button className="button btn-default" onClick={() => setShowFiltersDrawer(true)} title="Filters">
                        <FontAwesomeIcon icon="fa-solid fa-filter" />
                    </button>
                </div>
            </div>
            <div style={{ height: "85vh" }} className="mt-2 ag-theme-alpine">
                {loader ? <div className="w100"><SkeletonDataTable numSkeletons={20} /></div> :
                    <AgGridReact columnDefs={coldef} rowData={rowData} rowHeight={30} headerHeight={30} ref={gridRef} />
                }
            </div>

            {/* Right Panel Filters Drawer */}
            <div className={`sk-drawer-overlay ${showFiltersDrawer ? 'active' : ''}`} onClick={(e) => { if (e.target === e.currentTarget) setShowFiltersDrawer(false); }}>
                <div className={`sk-drawer-panel ${showFiltersDrawer ? 'open' : ''}`}>
                    <div className="sk-drawer-header">
                        <h5 className="sk-drawer-title">Filters</h5>
                        <div className="d-flex align-items-center gap-2">
                            <button className="sk-drawer-clear-btn" onClick={() => {
                                setHoveredRange([null, null]);
                                setFilterValues({ event_type: "All", approved: { label: "Pending", value: "p" } });
                            }}>Clear All</button>
                            <button className="sk-drawer-close-btn" onClick={() => setShowFiltersDrawer(false)}>
                                <FontAwesomeIcon icon="fa-solid fa-xmark" />
                            </button>
                        </div>
                    </div>
                    <div className="sk-drawer-body">
                        <div className='d-flex flex-column gap-4'>
                            {/* Date Picker Filter */}
                            <div className="sk-drawer-filter-group">
                                <div className="task-list-filter-label">Date Range</div>
                                <DatePicker
                                    ref={datePickerRef}
                                    value={hoveredRange}
                                    onChange={(date) => {
                                            if (!date || date.length === 2) {
                                                setHoveredRange(date);
                                        if (date && date.length === 2) {
                                            datePickerRef.current?.closeCalendar();
                                        }
                                            }
                                        }}
                                    range
                                    rangeHover
                                    style={{ width: "100%" }}
                                    containerStyle={{ width: "100%" }}
                                    inputClass="w-100 sk-input-dd"
                                    placeholder="Select Date"
                                />
                            </div>

                            {/* Event Type Filter */}
                            <div className="sk-drawer-filter-group">
                                <div className="task-list-filter-label">Event Type</div>
                                <div className='sk-segment-control mb-3'>
                                    {filterOpts?.event_type?.map((item) => (
                                        <button 
                                            key={item}
                                            type="button" 
                                            className={`sk-segment-btn ${filterValues?.event_type === item ? 'active' : ''}`}
                                            onClick={() => setFilterValues((prev) => ({...prev, event_type: item}))}
                                        >
                                            {item}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            {/* Approval Status Filter */}
                            <div className="sk-drawer-filter-group">
                                <div className="task-list-filter-label">Approval Status</div>
                                <div className='sk-segment-control mb-3'>
                                    {filterOpts?.approved?.map((item) => (
                                        <button 
                                            key={item?.value}
                                            type="button" 
                                            className={`sk-segment-btn ${filterValues?.approved?.value === item?.value ? 'active' : ''}`}
                                            onClick={() => setFilterValues((prev) => ({...prev, approved: item}))}
                                        >
                                            {item?.label}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="sk-drawer-footer">
                        <button className="sk-btn .sk-btn-primary-filter w-100 py-2" onClick={() => {
                            getEventsData();
                            setShowFiltersDrawer(false);
                        }}>Apply Filters</button>
                    </div>
                </div>
            </div>

            <Dialog visible={showPopup} onHide={() => setShowPopup(false)} draggable={false} className="modal-small" header="Event Banner Settings" style={{ maxHeight: "70%" }}>
                <div className="d-flex" style={{ height: "50vh" }}>
                    <div className="px-3 w50">
                        <div className="fs-6 fw-bold">Birthday Banner: </div>
                        {bannerLoader ? <div className="mt-2 text-center" style={{ height: "70%" }}><SkeletonContainer /></div> :
                            <div className="mt-2 text-center" style={{ height: "70%" }}>
                                {imagePreview?.birthday ? (
                                    <img
                                        src={imagePreview?.birthday}
                                        alt="Birthday Banner"
                                        style={{ width: 'auto', maxWidth: "70%", height: "100%", borderRadius: '8px' }}
                                    />
                                ) : (
                                    <div className='text-center'>
                                        <img src={"./assets/nodata.jpg"} alt='no data' />
                                        <p className='text-center red mt-3'> Data Not Found</p>
                                    </div>
                                )}
                            </div>
                        }
                        <div style={{ height: "20px" }} className="text-danger text-center">
                            {imageSelectedFlag?.birthday && "*The selected image needs to be saved"}
                        </div>
                        <div className="text-center mt-3">
                            <button className="button btn-default" onClick={() => { handleUploadClicked(true) }} style={{ width: "70px" }}>
                                {loaderBtn?.bupload ?
                                    <div className="spinner-border" role="status" style={{ width: "15px", height: "15px" }}>
                                        <span className="sr-only"></span> </div>
                                    :
                                    "Upload"
                                }
                            </button>
                            <button className="button btn-primary" onClick={() => { handleSaveBanner("birthday") }}>
                                {loaderBtn?.bsave ?
                                    <div className="spinner-border" role="status" style={{ width: "15px", height: "15px" }}>
                                        <span className="sr-only"></span> </div>
                                    :
                                    "Save"
                                }
                            </button>
                            <input className="d-none" type="file" placeholder="Upload Image" accept="image/*" onChange={(e) => handleFileChange(e, true)} ref={bInputRef} />
                        </div>
                    </div>
                    <div style={{ borderLeft: "1px solid #dee2e6" }} className="px-3 w50">
                        <div className="fs-6 fw-bold">Work Anniversary Banner: </div>
                        {bannerLoader ? <div className="mt-2 text-center" style={{ height: "70%" }}><SkeletonContainer /></div> :
                            <div className="mt-2 text-center" style={{ height: "70%" }}>
                                {imagePreview?.anniversary ? (
                                    <img
                                        src={imagePreview?.anniversary}
                                        alt="Anniversary Banner"
                                        style={{ width: 'auto', maxWidth: "70%", height: "100%", borderRadius: '8px' }}
                                    />
                                ) : (
                                    <div className='text-center'>
                                        <img src={"./assets/nodata.jpg"} alt='no data' />
                                        <p className='text-center red mt-3'> Data Not Found</p>
                                    </div>
                                )}
                            </div>
                        }
                        <div style={{ height: "20px" }} className="text-danger text-center">
                            {imageSelectedFlag?.anniversary && "*The selected image needs to be saved"}
                        </div>
                        <div className="text-center mt-3">
                            <button className="button btn-default" onClick={() => { handleUploadClicked(false) }} style={{ width: "70px" }}>
                                {loaderBtn?.aupload ?
                                    <div className="spinner-border" role="status" style={{ width: "15px", height: "15px" }}>
                                        <span className="sr-only"></span> </div>
                                    :
                                    "Upload"
                                }
                            </button>
                            <button className="button btn-primary" onClick={() => { handleSaveBanner("anniversary") }}>
                                {loaderBtn?.asave ?
                                    <div className="spinner-border" role="status" style={{ width: "15px", height: "15px" }}>
                                        <span className="sr-only"></span> </div>
                                    :
                                    "Save"
                                }
                            </button>
                            <input className="d-none" type="file" placeholder="Upload Image" accept="image/*" onChange={(e) => handleFileChange(e, false)} ref={aInputRef} />
                        </div>
                    </div>
                </div>
            </Dialog>

            <div>
                <CommanDialog visible={confirmation} handleClose={() => { setConfirmation(false); setRowData([...rowData]) }} handleFun={() => { handleApproveReject(false, true, dataToReject); }} message="Are you sure you want to reject?" />
            </div>

            <Dialog header="Email Template" visible={emailTemplate?.visible} onHide={() => setEmailTemplate((prev) => ({...prev, visible: false, html: ""})) } draggable={false} className="" style={{minWidth: "45vw"}}>
                <div dangerouslySetInnerHTML={{__html: emailTemplate?.html}}></div>
            </Dialog>
        </div>
    )
}

export default Events